import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';

import { SpinnerComponent } from '../../../common/components/spinner/spinner.component';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { selectCustomContentHtml } from '../../store/perks.selectors';
import { loadCustomContent } from '../../store/perks.thunk';

interface Props {
  id: string;
}

export const PerksCustomContentComponent = ({ id }: Props) => {
  const dispatch = useAppDispatch();
  const html = useAppSelector(selectCustomContentHtml(id));
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(loadCustomContent(id));
  }, [id]);

  useEffect(() => {
    if (!containerRef.current || !html) return;

    containerRef.current.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value)
      );
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode?.replaceChild(newScript, oldScript);
    });
  }, [html]);

  return (
    <div class="single-perks-custom-content">
      {!html && (
        <section class="single-loading">
          <SpinnerComponent />
        </section>
      )}

      {!!html && (
        <div
          ref={containerRef}
          class="single-custom-content-container"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  );
};
